import type { Page, RigListItem, RigListQuery } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import { SearchX } from 'lucide-react';
import { EmptyState } from '../../../../../shared/components/EmptyState';
import { ListSearch } from '../../../../../shared/components/ListSearch';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';
import { UnitPresets } from './UnitPresets';

interface UnitsTableProps {
  page: Page<RigListItem>;
  columns: TableColumnsType<RigListItem>;
  list: ListQueryControls<RigListQuery>;
  isRefreshing: boolean;
  /** A row click opens the unit; links and buttons in the row stop the click first. */
  onOpen: (rig: RigListItem) => void;
}

/** Search, the presets and the server-paged table; the old rows stay up, dimmed, while the next page loads. */
export function UnitsTable({ page, columns, list, isRefreshing, onOpen }: UnitsTableProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <ListSearch value={list.query.q} placeholder="Search truck or trailer registration" onSearch={(q) => list.setQuery({ q }, { replace: true })} />
        <UnitPresets list={list} />
      </div>
      <Table
        rowKey="key"
        dataSource={page.items}
        columns={columns}
        loading={isRefreshing}
        rowClassName="cursor-pointer"
        onRow={(rig) => ({ onClick: () => onOpen(rig) })}
        scroll={{ x: 'max-content' }}
        locale={
          list.isFiltered
            ? { emptyText: <EmptyState icon={SearchX} title="No matching units" description="No trucks or trailers match this search or these filters." /> }
            : undefined
        }
        {...list.tableProps<RigListItem>(page.total)}
      />
    </div>
  );
}
